<template>
  <div class="minheight100">
    <app-header v-if="appUser.isNative" back-type="back-app" title="友邻少年"></app-header>
    <div class="imgmax" style="text-align: center">
      <img src="../images//forever_vip_bg.png" />
    </div>
  </div>
</template>
<script>
import { appUser } from '@/utils'
export default {
  name: 'foreverVip',
  components: {},
  data() {
    return { appUser }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
